/*
  asvendo — Elektro-Rechner.

  Alle Rechner laufen vollstaendig im Browser: keine Anfrage an den Server, keine
  App, keine Daten verlassen das Geraet. Das ist bewusst so — die Seiten sollen
  auch auf der Baustelle mit schlechtem Netz sofort reagieren.

  Fachliche Grundlage der hier geänderten Cu-Tabelle:
    ABB Kabel- und Leitungsdimensionierung, Rev. H (07/2026), Tabelle 2
    (Cu/PVC, 70 °C, 30 °C, feste Verlegung und Dauerbetrieb).

  Spannungsfall-Prozentwerte sind ein vom Nutzer gewähltes Planungsziel. Die
  3-%-Auswahl erinnert an das Gesamtbudget hinter der Zähleranlage, das ABB
  im Beispiel auf DIN 18015-1 bezieht. Sie ist kein pauschales 3-%-Limit je
  Endstromkreis. Die 5-%-Auswahl ist ebenfalls kein pauschaler DIN-Grenzwert.

  Wichtig: die Ergebnisse sind eine Vorbemessung, keine Planung. Die Ausfuehrung
  bleibt einer Elektrofachkraft vorbehalten. Der Hinweis steht auf jeder Seite.
*/
(() => {
  "use strict";

  // Stand dieser Datei. Muss mit assets/asv-rechner-stand.json uebereinstimmen
  // und wird bei jeder Aenderung an den Normwerten erhoeht.
  //
  // Wozu: Shopify liefert eine Seite aus mehreren Zwischenspeichern aus, die
  // nicht gleichzeitig nachziehen. Am 28.07. waren drei Fassungen gleichzeitig
  // im Umlauf, die aelteste siebeneinhalb Stunden alt. Weil die Seite die
  // Versionsnummer der Skriptdatei fest in ihren Verweis schreibt, bekommt ein
  // Besucher mit alter Seite zwingend auch das alte Skript — und damit alte
  // Normwerte, ohne dass irgendetwas auffaellt.
  //
  // Deshalb holt sich das Skript den derzeit gueltigen Stand von einer Adresse
  // OHNE Versionsnummer (die liefert immer die aktuelle Datei) und vergleicht.
  // Passt es nicht, wird das Ergebnis nicht angezeigt, sondern die Bitte, die
  // Seite neu zu laden. Eine falsche Zahl, die niemand bemerkt, ist schlimmer
  // als ein Hinweis.
  //
  const STAND = 5;

  // --- Fachdaten -----------------------------------------------------------

  // ABB Rev. H (07/2026), Tabelle 2 (PDF-Seite 5): Strombelastbarkeit in Ampere.
  // Kupfer, PVC-isoliert (Betriebstemperatur 70 Grad), Umgebung 30 Grad,
  // feste Verlegung und Dauerbetrieb. Die 120 Werte unten wurden redaktionell
  // gegen die Auszuege in fachtabellen-quellen/rawcaptures abgeglichen
  // (A1/A2/B1/B2/C/E × 2/3 belastete Adern × 1,5–70 mm²); eine
  // elektrofachliche Freigabe liegt nicht vor. Die Tabelle enthält keine
  // Aluminiumwerte; diese werden niemals aus Cu abgeleitet.
  // BEGIN GENERATED BELASTBARKEIT — do not edit by hand
  const BELASTBARKEIT = {
    "A1": {
      "2": {
        "4": 26,
        "6": 34,
        "10": 46,
        "16": 61,
        "25": 80,
        "35": 99,
        "50": 119,
        "70": 151,
        "1.5": 15.5,
        "2.5": 19.5
      },
      "3": {
        "4": 24,
        "6": 31,
        "10": 42,
        "16": 56,
        "25": 73,
        "35": 89,
        "50": 108,
        "70": 136,
        "1.5": 13.5,
        "2.5": 18
      }
    },
    "A2": {
      "2": {
        "4": 25,
        "6": 32,
        "10": 43,
        "16": 57,
        "25": 75,
        "35": 92,
        "50": 110,
        "70": 139,
        "1.5": 15.5,
        "2.5": 18.5
      },
      "3": {
        "4": 23,
        "6": 29,
        "10": 39,
        "16": 52,
        "25": 68,
        "35": 83,
        "50": 99,
        "70": 125,
        "1.5": 13,
        "2.5": 17.5
      }
    },
    "B1": {
      "2": {
        "4": 32,
        "6": 41,
        "10": 57,
        "16": 76,
        "25": 101,
        "35": 125,
        "50": 151,
        "70": 192,
        "1.5": 17.5,
        "2.5": 24
      },
      "3": {
        "4": 28,
        "6": 36,
        "10": 50,
        "16": 68,
        "25": 89,
        "35": 110,
        "50": 134,
        "70": 171,
        "1.5": 15.5,
        "2.5": 21
      }
    },
    "B2": {
      "2": {
        "4": 30,
        "6": 38,
        "10": 52,
        "16": 69,
        "25": 90,
        "35": 111,
        "50": 133,
        "70": 168,
        "1.5": 16.5,
        "2.5": 23
      },
      "3": {
        "4": 27,
        "6": 34,
        "10": 46,
        "16": 62,
        "25": 80,
        "35": 99,
        "50": 118,
        "70": 149,
        "1.5": 15,
        "2.5": 20
      }
    },
    "C": {
      "2": {
        "4": 36,
        "6": 46,
        "10": 63,
        "16": 85,
        "25": 112,
        "35": 138,
        "50": 168,
        "70": 213,
        "1.5": 19.5,
        "2.5": 27
      },
      "3": {
        "4": 32,
        "6": 41,
        "10": 57,
        "16": 76,
        "25": 96,
        "35": 119,
        "50": 144,
        "70": 184,
        "1.5": 17.5,
        "2.5": 24
      }
    },
    "E": {
      "2": {
        "4": 40,
        "6": 51,
        "10": 70,
        "16": 94,
        "25": 119,
        "35": 148,
        "50": 180,
        "70": 232,
        "1.5": 22,
        "2.5": 30
      },
      "3": {
        "4": 34,
        "6": 43,
        "10": 60,
        "16": 80,
        "25": 101,
        "35": 126,
        "50": 153,
        "70": 196,
        "1.5": 18.5,
        "2.5": 25
      }
    }
  };
  const BELASTBARKEIT_FINGERPRINT = "868eb450595431b8bcbda81ada6a4160a04c3301d0505564df7fa3171d469b61";
  // END GENERATED BELASTBARKEIT

  const VERLEGEART_TEXT = {
    A1: "A1 — einadrige Leiter im Rohr in wärmegedämmter Wand",
    A2: "A2 — mehradrige Leitung im Rohr in wärmegedämmter Wand",
    B1: "B1 — einadrige Leiter im Rohr auf/in der Wand",
    B2: "B2 — Leitung im Rohr oder Kanal auf der Wand",
    C: "C — Leitung direkt auf der Wand",
    E: "E — Leitung frei in Luft",
  };

  // ABB Rev. H (07/2026), Tabelle 7 (PDF-Seite 9), erste Zeile: gleichartige,
  // gleich hoch belastete Kabel/Leitungen direkt gebündelt. Diese festgelegte
  // Modellzeile ersetzt keine Auswahl nach der tatsächlichen Geometrie. Ein
  // Drehstromkreis zählt als ein Stromkreis.
  //
  // Die Tabelle ist an den Spalten 1, 2, 3, 4, 5, 6, 8, 10, 12, 14 gestuft und
  // endet bei 14; größere Häufungen werden bewusst nicht hochgerechnet.
  // Stromkreiszahlen zwischen zwei Spalten (7, 9, 11, 13) werden auf die
  // naechsthoehere, also unguenstigere Stufe AUFGERUNDET. Der Faktor faellt mit
  // steigender Stromkreiszahl; fuer 7 Stromkreise ist deshalb der Wert der
  // Spalte 8 (0,52) und nicht der Spalte 6 (0,57) anzusetzen. Die frueher hier
  // verwendete naechstniedrigere Stufe ergab eine zu hohe Belastbarkeit.
  const HAEUFUNG = { 1: 1.0, 2: 0.8, 3: 0.7, 4: 0.65, 5: 0.6, 6: 0.57, 8: 0.52, 10: 0.48, 12: 0.45, 14: 0.43 };

  /**
   * Haeufungsfaktor fuer eine Verlegeart und eine Zahl von Stromkreisen.
   *
   * Dieser Rechner verwendet zwischen veröffentlichten Stützstellen bewusst
   * die nächsthöhere, also ungünstigere Stufe. Das ist eine konservative
   * Modellentscheidung und keine Aussage zur normativen Interpolation. Leere,
   * unbrauchbare und nicht ganzzahlige Eingaben ergeben keinen Faktor, ebenso
   * wie mehr als 14 Stromkreise, für die diese Tabelle keine Spalte mehr hat.
   *
   * Die Verlegeart wird nur zur Plausibilitaet geprueft. Der Rechner fragt keine
   * Einbaugeometrie ab und verwendet fest die Zeile "gebündelt" aus Tabelle 7.
   * Diese ist nicht in jeder Anordnung die ungünstigste: Einlagig unter der
   * Decke beträgt der Faktor bei einem Stromkreis 0,95 statt hier 1,00.
   * Andere Anordnungen sind anhand ihrer eigenen Tabellenzeile zu prüfen.
   */
  function haeufungsFaktor(verlegeart, stromkreise) {
    if (!BELASTBARKEIT[verlegeart]) return null;
    const n = Number(stromkreise);
    // Kein stilles Hochsetzen auf 1: leere oder unbrauchbare Eingaben erreichen
    // die Grenzenpruefung der Aufrufer und werden dort gemeldet.
    if (!Number.isInteger(n) || n < 1) return null;
    if (n > 14) return null;
    return naechsterFaktor(HAEUFUNG, n);
  }

  // ABB Rev. H (07/2026), Tabelle 5 (PDF-Seite 8): abweichende
  // Umgebungstemperatur, PVC (70 Grad). Stufenwerte von 10 °C bis 65 °C; bei
  // 70 °C weist die Tabelle fuer PVC-Leiter keinen Faktor mehr aus.
  // Zwischenwerte werden auf die naechsthoehere (ungünstigere) Temperaturstufe
  // aufgerundet — siehe naechsterFaktor().
  const TEMPERATUR = { 10: 1.22, 15: 1.17, 20: 1.12, 25: 1.06, 30: 1.0, 35: 0.94, 40: 0.87, 45: 0.79, 50: 0.71, 55: 0.61, 60: 0.5, 65: 0.35 };

  // Elektrische Leitfaehigkeit in m/(Ohm*mm2).
  //
  // Zwei Saetze, weil beide ihre Berechtigung haben:
  //   kalt (20 Grad)  — der uebliche deutsche Planungswert. Damit rechnen die
  //                     meisten Tabellenwerke und die meisten anderen Rechner.
  //   warm (70 Grad)  — der Leiterwiderstand steigt mit der Temperatur. Eine voll
  //                     belastete PVC-Leitung erreicht ihre Grenztemperatur von
  //                     70 Grad, dann faellt real rund ein Fuenftel mehr Spannung
  //                     ab als mit dem kalten Wert gerechnet.
  //
  // Die warmen Werte sind gerechnet, nicht geschaetzt:
  //   kappa(70) = kappa(20) / (1 + alpha * 50 K)
  //   Kupfer:    56 / (1 + 0,00393 * 50) = 56 / 1,1965 = 46,8
  //   Aluminium: 35 / (1 + 0,00403 * 50) = 35 / 1,2015 = 29,1
  // Frueher stand hier 44,4 bzw. 27,8. Das entspricht rund 90 Grad Leiter-
  // temperatur und gilt fuer vernetztes Polyethylen, nicht fuer die hier
  // zugrunde gelegte PVC-Leitung.
  // Der Rechner zeigt beide Saetze, damit die Annahme nicht im Verborgenen bleibt.
  const LEITWERT_SATZ = {
    kalt: { cu: 56, al: 35, text: "20 °C (üblicher Planungswert)" },
    warm: { cu: 46.8, al: 29.1, text: "70 °C (betriebswarm, konservativ)" },
  };
  const LEITWERT = LEITWERT_SATZ.kalt;

  const QUERSCHNITTE = [1.5, 2.5, 4, 6, 10, 16, 25, 35, 50, 70];

  // Genormte Nennstroeme von Leitungsschutzschaltern (DIN EN 60898-1).
  const LS_NENNSTROEME = [6, 10, 13, 16, 20, 25, 32, 40, 50, 63];

  // --- Hilfsmittel ---------------------------------------------------------

  const zahl = (v, nk = 2) =>
    Number(v).toLocaleString("de-DE", { minimumFractionDigits: nk, maximumFractionDigits: nk });

  const querschnittText = (a) => (Number.isInteger(a) ? `${a}` : zahl(a, 1)) + " mm²";

  /**
   * Faktor aus einer Tabelle mit Zahlenschluesseln, aufgerundet auf die
   * naechsthoehere veroeffentlichte Stuetzstelle.
   *
   * Die Quellentabellen sind gestuft. Dieser Rechner verwendet bewusst die
   * naechsthoehere, also unguenstigere Stufe. Das ist eine dokumentierte
   * konservative Modellwahl und keine Aussage zur normativen Interpolation.
   * Oberhalb der letzten Stufe kommt der letzte Tabellenwert zurück; die
   * Aufrufer begrenzen die Eingabe vorher.
   */
  function naechsterFaktor(tabelle, wert) {
    const keys = Object.keys(tabelle).map(Number).sort((a, b) => a - b);
    const treffer = keys.find((key) => key >= wert);
    return tabelle[treffer ?? keys[keys.length - 1]];
  }

  // --- Rechenkern ----------------------------------------------------------

  /**
   * Strom aus Leistung.
   * Wechselstrom:  I = P / (U * cos phi)
   * Drehstrom:     I = P / (Wurzel(3) * U * cos phi)
   */
  function stromAusLeistung(leistungW, spannungV, cosPhi, phasen) {
    const nenner = phasen === 3 ? Math.sqrt(3) * spannungV * cosPhi : spannungV * cosPhi;
    return leistungW / nenner;
  }

  /**
   * Spannungsfall in Volt fuer einen gegebenen Querschnitt.
   * Wechselstrom:  dU = 2 * L * I * cos phi / (kappa * A)   (Hin- und Rueckleiter)
   * Drehstrom:     dU = Wurzel(3) * L * I * cos phi / (kappa * A)
   */
  function spannungsfallV(laengeM, stromA, cosPhi, querschnittMm2, phasen, material, satz = "kalt") {
    const kappa = LEITWERT_SATZ[satz][material];
    const faktor = phasen === 3 ? Math.sqrt(3) : 2;
    return (faktor * laengeM * stromA * cosPhi) / (kappa * querschnittMm2);
  }

  /** Kleinster Querschnitt, der die Strombelastbarkeit einhaelt. */
  function querschnittNachStrom(stromA, verlegeart, adern, haeufung, tempC) {
    const fH = haeufungsFaktor(verlegeart, haeufung);
    const fT = naechsterFaktor(TEMPERATUR, tempC);
    if (!Number.isFinite(fH)) return { querschnitt: null, belastbarkeit: null, faktorHaeufung: null, faktorTemp: fT, grund: "haeufung" };
    const gesamt = fH * fT;
    const tabelle = BELASTBARKEIT[verlegeart][adern];
    for (const a of QUERSCHNITTE) {
      if (tabelle[a] != null && tabelle[a] * gesamt >= stromA) {
        return { querschnitt: a, belastbarkeit: tabelle[a] * gesamt, faktorHaeufung: fH, faktorTemp: fT };
      }
    }
    return { querschnitt: null, belastbarkeit: null, faktorHaeufung: fH, faktorTemp: fT };
  }

  /** Kleinster Querschnitt, der den zulaessigen Spannungsfall einhaelt. */
  function querschnittNachSpannungsfall(laengeM, stromA, cosPhi, spannungV, prozent, phasen, material, satz = "kalt") {
    const zulaessigV = (prozent / 100) * spannungV;
    for (const a of QUERSCHNITTE) {
      if (spannungsfallV(laengeM, stromA, cosPhi, a, phasen, material, satz) <= zulaessigV) {
        return { querschnitt: a, zulaessigV };
      }
    }
    return { querschnitt: null, zulaessigV };
  }

  /**
   * Leitungsschutzschalter fuer einen bekannten Verbraucher.
   * Bedingung aus VDE 0100-430: Ib <= In <= Iz — der Nennstrom muss den
   * Betriebsstrom tragen und darf die Leitung nicht ueberlasten.
   *
   * Gewaehlt wird der KLEINSTE passende Nennstrom, nicht der groesste. Beispiel:
   * eine 11-kW-Wallbox zieht 15,9 A an 2,5 mm2 (belastbar 20 A). Erlaubt waeren
   * B16 und B20, sinnvoll ist B16 — B20 wuerde den Verbraucher im Fehlerfall
   * erst spaeter abschalten, ohne dass jemand etwas davon haette.
   */
  function passenderLs(stromA, belastbarkeitA) {
    return LS_NENNSTROEME.find((i) => i >= stromA && i <= belastbarkeitA) ?? null;
  }

  /**
   * Groesster Leitungsschutzschalter, den eine Leitung noch vertraegt.
   * Das ist die Frage der Tabellenseite ("was darf ich hier maximal davorsetzen"),
   * nicht die Frage des Auslegungsrechners ("was passt zu diesem Verbraucher").
   */
  function groessterLs(belastbarkeitA) {
    const tauglich = LS_NENNSTROEME.filter((i) => i <= belastbarkeitA);
    return tauglich.length ? tauglich[tauglich.length - 1] : null;
  }

  // --- Oberflaeche ---------------------------------------------------------

  const el = (sel, wurzel = document) => wurzel.querySelector(sel);
  const alle = (sel, wurzel = document) => [...wurzel.querySelectorAll(sel)];

  function wertVon(wurzel, name, standard = 0) {
    const f = el(`[data-feld="${name}"]`, wurzel);
    if (!f) return standard;
    const v = f.type === "checkbox" ? f.checked : f.value;
    if (typeof v === "boolean") return v;
    const text = String(v).trim();
    // Ein leeres oder unlesbares Feld ist keine gueltige Zahl. NaN erreicht die
    // Grenzenpruefungen der Rechner, statt still den Standardwert einzusetzen;
    // nur ein fehlendes Feld liefert weiterhin den uebergebenen Standard.
    if (!text) return NaN;
    const n = parseFloat(text.replace(",", "."));
    return Number.isFinite(n) ? n : NaN;
  }

  function zeigeErgebnis(wurzel, html) {
    const ziel = el("[data-ergebnis]", wurzel);
    if (ziel) { ziel.innerHTML = html; ziel.hidden = false; }
  }

  // --- Produktanbindung ----------------------------------------------------
  //
  // Der Kern des Ganzen: wer gerade ausgerechnet hat, dass er B16 braucht, soll
  // B16 nicht anschliessend suchen muessen. Das Ergebnis nennt deshalb den
  // konkreten Artikel mit Preis und Warenkorb-Knopf. Die Menge ist vorbelegt,
  // damit auf dem Handy kein zusaetzlicher Tastendruck noetig ist.

  // Pro Wurzel cachen: eine Seite kann mehrere Rechner-Sections mit jeweils
  // eigenem data-produkte tragen; ein globaler Cache wuerde allen die Liste
  // des ersten Rechners geben.
  const produktCaches = new WeakMap();
  function produkte(wurzel) {
    if (produktCaches.has(wurzel)) return produktCaches.get(wurzel);
    let liste;
    try { liste = JSON.parse(wurzel.getAttribute("data-produkte") || "[]"); }
    catch { liste = []; }
    produktCaches.set(wurzel, liste);
    return liste;
  }

  // Verteiler werden ausschließlich anhand gepflegter Metafelder gefiltert.
  // Bei Mehrvarianten-Produkten müssen alle vier Eigenschaften an der Variante
  // stehen. Produktwerte sind nur beim echten Einvarianten-Produkt zulässig;
  // so wird eine Größe oder IP nie still von einer anderen Variante geerbt.
  const positiveGanzzahl = (value) => {
    const number = Number(value);
    return Number.isInteger(number) && number > 0 ? number : null;
  };
  const ipMetafeld = (value) => {
    const found = String(value ?? "").trim().toUpperCase().match(/^IP\s*(\d)(\d|X)$/);
    return found ? `IP${found[1]}${found[2]}` : null;
  };
  const montageMetafeld = (value) => String(value ?? "").toUpperCase()
    .split(/[^A-Z]+/).filter(Boolean);
  function verteilerMetafelder(v) {
    const aus = (prefix) => ({
      te: positiveGanzzahl(v[`${prefix}_te_gesamt`]),
      reihen: positiveGanzzahl(v[`${prefix}_reihen`]),
      montage: montageMetafeld(v[`${prefix}_montage`]),
      ip: ipMetafeld(v[`${prefix}_ip`]),
    });
    const variant = aus("variant");
    if (variant.te !== null && variant.reihen !== null && variant.montage.length && variant.ip) return variant;
    if (Number(v.varianten_anzahl) !== 1) return null;
    const product = aus("product");
    return product.te !== null && product.reihen !== null && product.montage.length && product.ip ? product : null;
  }
  function findeVerteiler(wurzel, teBedarf, reihenBedarf, montage, ip) {
    return produkte(wurzel).map((v) => ({ v, meta: verteilerMetafelder(v) })).filter(({ meta }) => {
      if (!meta || meta.te < teBedarf || meta.reihen < reihenBedarf) return false;
      if (montage !== "egal" && !meta.montage.includes(montage)) return false;
      // IP 67 ist nicht automatisch gleich/besser als IP 65: Auswahl und
      // Produktmetafeld müssen exakt übereinstimmen, einschließlich IP Xn.
      if (ip !== "egal" && meta.ip !== ip) return false;
      return true;
    }).sort((a, b) =>
      (a.meta.te - b.meta.te) ||
      (a.meta.reihen - b.meta.reihen) ||
      (a.v.preis - b.v.preis) ||
      String(a.v.produkt).localeCompare(String(b.v.produkt), "de")
    ).slice(0, 3).map(({ v, meta }) => ({ ...v, verteiler_te_gesamt: meta.te, verteiler_reihen: meta.reihen }));
  }

  const preisText = (cent) =>
    (cent / 100).toLocaleString("de-DE", { style: "currency", currency: "EUR" });

  /**
   * Text fuer die Ausgabe per innerHTML entschaerfen.
   * Die Artikeldaten stammen aus der Warenwirtschaft, nicht vom Besucher — aber
   * ein Artikelname mit spitzen Klammern wuerde die Trefferliste zerlegen, und
   * beim naechsten Datenimport will niemand daran denken.
   */
  const sicher = (s) => String(s ?? "").replace(/[&<>"']/g, (c) =>
    ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));

  /**
   * Sucht Varianten, deren Text alle Suchmuster enthaelt.
   * Gesucht wird in Variantenbezeichnung und Artikelnummer zusammen, weil die
   * Technik mal im einen und mal im anderen Feld steckt: "1-polig B 16A" gegen
   * "A00-S7-1P-B-16" beschreiben dasselbe Geraet.
   */
  function findeVarianten(wurzel, muster, grenze = 3) {
    const liste = produkte(wurzel);
    const treffer = liste.filter((v) => {
      // Ausführung nur an Variante/SKU erkennen: ein Produkttitel wie
      // „B C 1- und 3-polig“ beschreibt mehrere unterschiedliche Varianten.
      const text = `${v.titel} ${v.sku}`.toLowerCase();
      return muster.every((m) => (m instanceof RegExp ? m.test(text) : text.includes(String(m).toLowerCase())));
    });
    // Lieferbares zuerst, dann guenstigstes.
    treffer.sort((a, b) => (b.lager - a.lager) || (a.preis - b.preis));
    return treffer.slice(0, grenze);
  }

  function produktKarten(titelZeile, varianten, menge = 1) {
    if (!varianten.length) return "";
    const zeilen = varianten.map((v) => `
      <li class="asv-treffer">
        <a class="asv-treffer__name" href="${sicher(v.url)}">
          <span class="asv-treffer__produkt">${sicher(v.produkt)}</span>
          <span class="asv-treffer__variante">${sicher(v.titel)}${v.verteiler_te_gesamt ? ` — ${zahl(v.verteiler_te_gesamt, 0)} TE` : ""}</span>
        </a>
        <span class="asv-treffer__preis">${preisText(v.preis)}</span>
        ${v.lager
          ? `<form action="/cart/add" method="post" class="asv-treffer__form">
               <input type="hidden" name="id" value="${Number(v.id)}">
               <input type="number" name="quantity" value="${Number(menge)}" min="1" aria-label="Menge" class="asv-treffer__menge">
               <button type="submit" class="asv-treffer__knopf">In den Warenkorb</button>
             </form>`
          : `<span class="asv-treffer__aus">derzeit nicht lieferbar</span>`}
      </li>`).join("");
    return `<div class="asv-rechner__weiter">
      <p class="asv-rechner__weiter-titel">${titelZeile}</p>
      <ul class="asv-treffer-liste">${zeilen}</ul>
    </div>`;
  }

  // --- Rechner 1: Kabelquerschnitt ----------------------------------------

  function rechneKabelquerschnitt(wurzel) {
    const modus = el('[data-feld="modus"]', wurzel)?.value || "leistung";
    const phasen = Number(wertVon(wurzel, "phasen", 1));
    const spannung = phasen === 3 ? 400 : 230;
    // Nur ein fehlendes Feld erhält den Standardwert. Leere und ungültige
    // Eingaben bleiben NaN und erreichen die Grenzprüfung.
    const cosPhi = Number(wertVon(wurzel, "cosphi", 1));
    const laenge = Number(wertVon(wurzel, "laenge", 0));
    const material = el('[data-feld="material"]', wurzel)?.value || "cu";
    const verlegeart = el('[data-feld="verlegeart"]', wurzel)?.value || "B2";
    const adern = phasen === 3 ? 3 : 2;
    const haeufung = Number(wertVon(wurzel, "haeufung", 1));
    const temp = Number(wertVon(wurzel, "temperatur", 30));
    const grenze = Number(wertVon(wurzel, "spannungsfall", 3));
    const profil = el('[data-feld="spannungsfallprofil"]', wurzel)?.selectedOptions?.[0]?.textContent?.trim() || "individuelles Planungsziel";
    const satz = el('[data-feld="leitertemperatur"]', wurzel)?.value || "kalt";

    let strom;
    if (modus === "strom") {
      strom = Number(wertVon(wurzel, "strom", 0));
    } else {
      const leistung = Number(wertVon(wurzel, "leistung", 0));
      strom = stromAusLeistung(leistung, spannung, cosPhi, phasen);
    }

    if (!(strom > 0) || !(laenge > 0) || !(cosPhi >= 0.3 && cosPhi <= 1) || !(grenze >= 0.5 && grenze <= 10) || !(temp >= 10 && temp <= 65)) {
      zeigeErgebnis(wurzel, `<p class="asv-rechner__hinweis">Bitte Leistung beziehungsweise Strom, Länge, cos φ, Umgebungstemperatur und Spannungsfallziel innerhalb der angegebenen Grenzen eingeben.</p>`);
      return;
    }

    if (!Number.isInteger(haeufung) || haeufung < 1) {
      zeigeErgebnis(wurzel, `<p class="asv-rechner__hinweis">Bitte die Zahl der gebündelten Stromkreise als ganze Zahl ab 1 eintragen.</p>`);
      return;
    }

    if (haeufung > 14) {
      zeigeErgebnis(wurzel, `<p class="asv-rechner__warnung"><strong>Für mehr als 14 gebündelte Stromkreise gibt dieser Rechner kein Ergebnis aus.</strong> Die verwendete ABB-Tabelle 7 endet dort; Einbaugeometrie und Reduktionsfaktor müssen fachlich bestimmt werden.</p>`);
      return;
    }

    // Die Belastbarkeitstabelle gilt fuer Kupfer. Aluminium traegt bei gleichem
    // Querschnitt deutlich weniger Strom; die Kupferwerte darauf anzuwenden
    // waere eine Unterdimensionierung, und zwar eine unsichtbare — die Zahl
    // sieht aus wie jede andere. Solange keine geprueften Aluminiumtabellen
    // hinterlegt sind, gibt dieser Rechner dazu kein Ergebnis aus.
    // Der Spannungsfallrechner rechnet Aluminium weiterhin, dort haengt das
    // Ergebnis nur an der Leitfaehigkeit und die ist materialrichtig hinterlegt.
    if (material !== "cu") {
      zeigeErgebnis(wurzel, `<p class="asv-rechner__warnung"><strong>Für Aluminium gibt dieser Rechner keine Empfehlung aus.</strong>
        Die hinterlegte Strombelastbarkeit gilt für Kupferleiter. Aluminium trägt bei gleichem Querschnitt
        deutlich weniger Strom — die Kupferwerte darauf anzuwenden, hieße die Leitung zu unterdimensionieren.
        <br><br>Für den reinen Spannungsfall bei Aluminium nutzen Sie den
        <a href="/pages/spannungsfall-rechner">Spannungsfallrechner</a>; dort ist die Leitfähigkeit
        materialrichtig hinterlegt. Die Auslegung nach Strombelastbarkeit gehört bei Aluminium
        in die Hand einer Elektrofachkraft mit den Tabellen für Aluminiumleiter.</p>`);
      return;
    }

    const nachStrom = querschnittNachStrom(strom, verlegeart, adern, haeufung, temp);
    const nachFall = querschnittNachSpannungsfall(laenge, strom, cosPhi, spannung, grenze, phasen, material, satz);

    if (!nachStrom.querschnitt || !nachFall.querschnitt) {
      zeigeErgebnis(wurzel, `<p class="asv-rechner__warnung"><strong>Kein Querschnitt bis 70 mm² reicht aus.</strong>
        Bei ${zahl(strom, 1)} A und ${zahl(laenge, 0)} m ist das eine Aufgabe für die Fachplanung —
        hier kommen Parallelverlegung oder eine andere Netzform ins Spiel.</p>`);
      return;
    }

    const empfohlen = Math.max(nachStrom.querschnitt, nachFall.querschnitt);
    const massgeblich = nachFall.querschnitt > nachStrom.querschnitt ? "der Spannungsfall" : "die Strombelastbarkeit";
    const fallBeiEmpfohlen = spannungsfallV(laenge, strom, cosPhi, empfohlen, phasen, material, satz);
    const fallProzent = (fallBeiEmpfohlen / spannung) * 100;
    const anderer = satz === "kalt" ? "warm" : "kalt";
    const fallAnders = (spannungsfallV(laenge, strom, cosPhi, empfohlen, phasen, material, anderer) / spannung) * 100;

    // Der Schutzschalter gehoert vor die Leitung, die tatsaechlich verlegt wird.
    // Erzwingt der Spannungsfall einen groesseren Querschnitt, ist dessen
    // Belastbarkeit massgeblich — nicht die des kleineren, der nur rechnerisch
    // aus der Strombetrachtung fiel.
    //
    // Der Griff in die Tabelle wird abgesichert: fehlt dort ein Querschnitt,
    // kaeme NaN heraus und der Schalter verschwaende wortlos aus dem Ergebnis.
    // Dann lieber der Wert aus der Strombetrachtung — kleiner, also unbedenklich.
    const basisEmpfohlen = BELASTBARKEIT[verlegeart][adern][empfohlen];
    const izEmpfohlen = Number.isFinite(basisEmpfohlen)
      ? basisEmpfohlen * nachStrom.faktorHaeufung * nachStrom.faktorTemp
      : nachStrom.belastbarkeit;
    const ls = passenderLs(strom, izEmpfohlen);

    // Ein Drehstromkreis braucht ein Schutzgerät fuer alle drei Aussenleiter.
    // Vorher stand hier fest "1-polig" — die Rechnung war dreiphasig, der
    // vorgeschlagene Artikel einpolig. Wer das bestellt, schuetzt zwei Leiter
    // nicht. Die Polzahl muss aus der gewaehlten Netzform folgen.
    const polig = phasen === 3 ? 3 : 1;
    const poligMuster = phasen === 3 ? /3[\s-]?p(olig)?/i : /1[\s-]?p(olig)?/i;

    zeigeErgebnis(wurzel, `
      <div class="asv-rechner__treffer" data-spannungsfall-v="${fallBeiEmpfohlen.toFixed(4)}" data-spannungsfall-prozent="${fallProzent.toFixed(4)}">
        <span class="asv-rechner__treffer-label">Empfohlener Querschnitt</span>
        <span class="asv-rechner__treffer-wert">${querschnittText(empfohlen)}</span>
        <span class="asv-rechner__treffer-zusatz">maßgeblich ist ${massgeblich}</span>
      </div>
      <dl class="asv-rechner__details">
        <div><dt>Betriebsstrom</dt><dd>${zahl(strom, 1)} A${modus === "leistung" ? " (aus der Leistung berechnet)" : ""}</dd></div>
        <div><dt>Nach Strombelastbarkeit</dt><dd>${querschnittText(nachStrom.querschnitt)} — belastbar bis ${zahl(nachStrom.belastbarkeit, 1)} A</dd></div>
        <div><dt>Nach Spannungsfall</dt><dd>${querschnittText(nachFall.querschnitt)} — zulässig sind ${zahl(nachFall.zulaessigV, 1)} V (${zahl(grenze, 1)} %)</dd></div>
        <div><dt>Spannungsfall bei ${querschnittText(empfohlen)}</dt><dd>${zahl(fallBeiEmpfohlen, 2)} V = ${zahl(fallProzent, 2)} %</dd></div>
        <div><dt>Gerechnet mit</dt><dd>${LEITWERT_SATZ[satz].text} — bei ${LEITWERT_SATZ[anderer].text.split(" (")[0]} wären es ${zahl(fallAnders, 2)} %</dd></div>
        <div><dt>Umrechnungsfaktoren</dt><dd>Häufung ${zahl(nachStrom.faktorHaeufung, 2)} × Temperatur ${zahl(nachStrom.faktorTemp, 2)}</dd></div>
        <div><dt>Verlegeart</dt><dd>${VERLEGEART_TEXT[verlegeart]}</dd></div>
        ${ls ? `<div><dt>Möglicher Leitungsschutzschalter</dt><dd>B${ls} oder C${ls} — trägt ${zahl(strom, 1)} A Betriebsstrom, die ${querschnittText(empfohlen)} sind unter diesen Bedingungen bis ${zahl(izEmpfohlen, 1)} A belastbar</dd></div>` : ""}
      </dl>
      <p class="asv-rechner__fussnote">Spannungsfallziel: ${sicher(profil)}. Der Zielwert ist für den betrachteten Leitungsabschnitt zu prüfen; 3 % sind kein pauschaler Wert je Endstromkreis und 5 % keine pauschale DIN-Grenze.
      <br><br>Häufungsfaktor nach Tabelle 7, festgelegte Modellzeile „gebündelt“ für gleichartige, gleich hoch belastete Kabel oder Leitungen. Die tatsächliche Anordnung wird nicht abgefragt. Andere Geometrien benötigen ihre eigene Tabellenzeile; beispielsweise gilt einlagig unter der Decke bei einem Stromkreis 0,95 statt der hier verwendeten 1,00. Die Stromkreiszahl wird innerhalb der Modellzeile auf die nächsthöhere Tabellenstufe aufgerundet. Temperaturfaktor nach Tabelle 5, ebenfalls auf die nächsthöhere Stufe aufgerundet.
      <br><br>Der angezeigte Bemessungsstrom erfüllt im Rechnervergleich Ib ≤ In ≤ Iz. Für ein konkretes Schutzgerät ist zusätzlich dessen Kennwert I2 gegen die Leitungsbelastbarkeit sowie Kurzschlussschutz, Abschaltbedingung, Selektivität und die Anschlussbedingungen zu prüfen.</p>
      ${ls ? produktKarten(
        `Leitungsschutzschalter B${ls} oder C${ls}, ${polig}-polig — Auslösecharakteristik prüfen`,
        findeVarianten(wurzel, [new RegExp(`\\b[bc][\\s/-]*0?${ls}\\b`, "i"), poligMuster]),
        1
      ) : ""}
    `);
  }

  // --- Rechner 2: Spannungsfall -------------------------------------------

  function rechneSpannungsfall(wurzel) {
    const modus = el('[data-feld="modus"]', wurzel)?.value || "strom";
    const phasen = Number(wertVon(wurzel, "phasen", 1));
    const spannung = phasen === 3 ? 400 : 230;
    // Wie im Kabelrechner bleiben leere und ungültige Werte für die
    // Grenzprüfung erhalten; nur ein fehlendes Feld erhält den Standardwert.
    const cosPhi = Number(wertVon(wurzel, "cosphi", 1));
    const strom = modus === "leistung"
      ? stromAusLeistung(Number(wertVon(wurzel, "leistung", 0)), spannung, cosPhi, phasen)
      : Number(wertVon(wurzel, "strom", 0));
    const laenge = Number(wertVon(wurzel, "laenge", 0));
    const querschnitt = Number(wertVon(wurzel, "querschnitt", 1.5));
    const material = el('[data-feld="material"]', wurzel)?.value || "cu";
    const satz = el('[data-feld="leitertemperatur"]', wurzel)?.value || "kalt";
    const grenze = Number(wertVon(wurzel, "spannungsfall", 3));
    const profil = el('[data-feld="spannungsfallprofil"]', wurzel)?.selectedOptions?.[0]?.textContent?.trim() || "individuelles Planungsziel";

    if (!(strom > 0) || !(laenge > 0) || !(querschnitt > 0) || !(cosPhi >= 0.3 && cosPhi <= 1) || !(grenze >= 0.5 && grenze <= 10)) {
      zeigeErgebnis(wurzel, `<p class="asv-rechner__hinweis">Bitte Leistung beziehungsweise Strom, Länge, Querschnitt, cos φ und Spannungsfallziel innerhalb der angegebenen Grenzen eingeben.</p>`);
      return;
    }

    const fallV = spannungsfallV(laenge, strom, cosPhi, querschnitt, phasen, material, satz);
    const prozent = (fallV / spannung) * 100;
    const anderer = satz === "kalt" ? "warm" : "kalt";
    const prozentAnders = (spannungsfallV(laenge, strom, cosPhi, querschnitt, phasen, material, anderer) / spannung) * 100;
    const spannungAmVerbraucher = spannung - fallV;

    const zielErfuellt = prozent <= grenze;
    const bewertung = zielErfuellt
      ? `Das gewählte Planungsziel von ${zahl(grenze, 1)} % wird eingehalten. Der gesamte Leitungsweg und die Anforderungen der konkreten Anlage bleiben zu prüfen.`
      : `Das gewählte Planungsziel von ${zahl(grenze, 1)} % wird überschritten. Größerer Querschnitt oder kürzerer Weg prüfen.`;
    const klasse = zielErfuellt ? "gut" : "warnung";

    const besser = QUERSCHNITTE.find((a) => (spannungsfallV(laenge, strom, cosPhi, a, phasen, material, satz) / spannung) * 100 <= grenze);

    zeigeErgebnis(wurzel, `
      <div class="asv-rechner__treffer asv-rechner__treffer--${klasse}" data-spannungsfall-v="${fallV.toFixed(4)}" data-spannungsfall-prozent="${prozent.toFixed(4)}">
        <span class="asv-rechner__treffer-label">Spannungsfall</span>
        <span class="asv-rechner__treffer-wert">${zahl(prozent, 2)} %</span>
        <span class="asv-rechner__treffer-zusatz">${zahl(fallV, 2)} V von ${spannung} V</span>
      </div>
      <p class="asv-rechner__bewertung asv-rechner__bewertung--${klasse}">${bewertung}</p>
      <dl class="asv-rechner__details">
        <div><dt>Spannung am Verbraucher</dt><dd>${zahl(spannungAmVerbraucher, 1)} V</dd></div>
        <div><dt>Leitermaterial</dt><dd>${material === "cu" ? "Kupfer" : "Aluminium"}, gerechnet mit ${zahl(LEITWERT_SATZ[satz][material], 1)} m/Ω·mm²</dd></div>
        <div><dt>Leitertemperatur</dt><dd>${LEITWERT_SATZ[satz].text} — bei ${LEITWERT_SATZ[anderer].text.split(" (")[0]} wären es ${zahl(prozentAnders, 2)} %</dd></div>
        <div><dt>Netzform</dt><dd>${phasen === 3 ? "Drehstrom 400 V" : "Wechselstrom 230 V"}</dd></div>
        <div><dt>Spannungsfallziel</dt><dd>${zahl(grenze, 1)} % — ${sicher(profil)}</dd></div>
        ${besser && besser > querschnitt ? `<div><dt>Unter ${zahl(grenze, 1)} % käme man mit</dt><dd>${querschnittText(besser)}</dd></div>` : ""}
      </dl>
      <p class="asv-rechner__fussnote">Das Modell berechnet den ohmschen Spannungsfall. Reaktanz, Netzimpedanz, Leiteranordnung und unsymmetrische Belastung sind nicht enthalten; bei cos φ kleiner als 1 kann der tatsächliche Wechselspannungsfall deshalb abweichen. Das Ziel ist ein Planungsziel, keine pauschale Normgrenze.<br><br>Aluminium wird hier nur für den Spannungsfall mit materialrichtiger Leitfähigkeit gerechnet. Eine Strombelastbarkeits-Auslegung für Aluminium ist nicht enthalten.</p>
    `);
  }

  // --- Rechner 3: Verteilergroesse / Teilungseinheiten --------------------

  // Die Eingabe je Gerät ist absichtlich variabel: DIN 43880 beschreibt das
  // Raster, nicht die Breite jedes konkreten Produkts. Voreinstellungen stammen
  // aus dem bisherigen Rechner und müssen gegen das Produktdatenblatt geprüft
  // werden. Neue Gerätetypen haben daher keine erfundene Standardbreite.
  const TE_GERAETE = [
    { id: "ls1", titel: "Leitungsschutzschalter 1-polig" },
    { id: "ls3", titel: "Leitungsschutzschalter 3-polig" },
    { id: "fi2", titel: "FI-Schutzschalter 2-polig" },
    { id: "fi4", titel: "FI-Schutzschalter 4-polig" },
    { id: "fils", titel: "FI/LS kombiniert (1+N)" },
    { id: "spd", titel: "Überspannungsableiter Typ 2" },
    { id: "hs", titel: "Hauptschalter 4-polig" },
    { id: "schuetz", titel: "Installationsschütz" },
    { id: "zeit", titel: "Zeitschaltuhr / Dämmerungsschalter" },
    { id: "klingel", titel: "Klingeltrafo" },
    { id: "sonstige", titel: "Sonstige Geräte" },
    { id: "zaehler", titel: "Zähler" },
    { id: "relais", titel: "Installationsrelais" },
    { id: "dinsteckdose", titel: "Hutschienen-Steckdose" },
    { id: "blindabdeckung", titel: "Blindabdeckung" },
  ];

  function rechneVerteiler(wurzel) {
    let te = 0;
    const zeilen = [];
    const ohneTe = [];
    for (const g of TE_GERAETE) {
      const n = Number(wertVon(wurzel, `anzahl_${g.id}`, 0));
      const teFeld = el(`[data-feld="te_${g.id}"]`, wurzel);
      const teJeGeraet = Number(String(teFeld?.value ?? "").replace(",", "."));
      if (!Number.isInteger(n) || n < 0) {
        zeigeErgebnis(wurzel, `<p class="asv-rechner__hinweis">Geräteanzahlen müssen ganze Zahlen ab 0 sein.</p>`);
        return;
      }
      if (n > 0 && (!Number.isFinite(teJeGeraet) || teJeGeraet <= 0 || teJeGeraet > 24)) ohneTe.push(g.titel);
      if (n > 0 && Number.isFinite(teJeGeraet) && teJeGeraet > 0 && teJeGeraet <= 24) {
        te += n * teJeGeraet;
        zeilen.push(`<div><dt>${sicher(g.titel)}</dt><dd>${n} × ${zahl(teJeGeraet, 1)} TE = ${zahl(n * teJeGeraet, 1)} TE</dd></div>`);
      }
    }
    if (ohneTe.length) {
      zeigeErgebnis(wurzel, `<p class="asv-rechner__warnung"><strong>TE-Angabe aus dem Datenblatt fehlt.</strong> Bitte für ${ohneTe.map(sicher).join(", ")} die Teilungseinheiten je konkretem Gerät eintragen. Der Rechner setzt keine universale Gerätebreite voraus.</p>`);
      return;
    }
    const reserveProzent = Number(wertVon(wurzel, "reserve", 20));
    const proReihe = Number(wertVon(wurzel, "proreihe", 12));
    const montage = el('[data-feld="montage"]', wurzel)?.value || "egal";
    const ip = el('[data-feld="ip"]', wurzel)?.value || "egal";

    if (te === 0 || !(reserveProzent >= 0 && reserveProzent <= 100) || ![12, 18, 24].includes(proReihe)) {
      zeigeErgebnis(wurzel, `<p class="asv-rechner__hinweis">Tragen Sie ein, wie viele Geräte in den Verteiler sollen.</p>`);
      return;
    }

    const mitReserve = Math.ceil(te * (1 + reserveProzent / 100));
    const reihen = Math.ceil(mitReserve / proReihe);
    const plaetzeGesamt = reihen * proReihe;
    const freiTe = plaetzeGesamt - te;

    zeigeErgebnis(wurzel, `
      <div class="asv-rechner__treffer">
        <span class="asv-rechner__treffer-label">Empfohlene Verteilergröße</span>
        <span class="asv-rechner__treffer-wert">${reihen}-reihig</span>
        <span class="asv-rechner__treffer-zusatz">${plaetzeGesamt} Teilungseinheiten bei ${proReihe} TE je Reihe</span>
      </div>
      <dl class="asv-rechner__details">
        ${zeilen.join("")}
        <div><dt>Belegt</dt><dd>${te} TE</dd></div>
        <div><dt>Mit ${reserveProzent} % Reserve</dt><dd>${mitReserve} TE</dd></div>
        <div><dt>Frei nach Einbau</dt><dd>${freiTe} TE (${Math.round((freiTe / plaetzeGesamt) * 100)} % des Verteilers)</dd></div>
      </dl>
      <p class="asv-rechner__fussnote">Eine TE beschreibt das Raster, nicht die Breite aller Geräte. Prüfen Sie jede eingegebene TE-Angabe am konkreten Datenblatt. Die Reserve ist eine Planungsannahme und keine pauschale Normvorgabe.</p>
      ${produktKarten(
        `Verifizierte Verteiler mit mindestens ${mitReserve} TE und ${reihen} Reihe${reihen === 1 ? "" : "n"}`,
        findeVerteiler(wurzel, mitReserve, reihen, montage, ip),
        1
      )}
      ${produkte(wurzel).length && !findeVerteiler(wurzel, mitReserve, reihen, montage, ip).length
        ? `<p class="asv-rechner__hinweis">Kein kaufbarer Verteiler mit vollständigen, passenden Variantenmetafeldern asv.te_gesamt, asv.reihen, asv.montage und asv.ip gefunden. Bei Mehrvarianten-Produkten werden Produkteigenschaften nicht auf Varianten übertragen; es wird keine Titel- oder IP-Schätzung als Ersatz ausgegeben.</p>`
        : ""}
    `);
  }

  // --- Rechner 4: FI-Typ bestimmen ----------------------------------------

  const FI_FRAGEN = [
    { id: "wallbox", text: "Ladeeinrichtung für ein Elektrofahrzeug (Wallbox)" },
    { id: "pv", text: "Photovoltaik-Wechselrichter ohne galvanische Trennung" },
    { id: "fu3", text: "Dreiphasiger Frequenzumrichter, Aufzug, drehzahlgeregelte Wärmepumpe" },
    { id: "einphasig_elektronik", text: "Einphasige Geräte mit Elektronik (Waschmaschine, Induktionsherd, LED-Dimmer)" },
    { id: "standard", text: "Normale Endstromkreise: Steckdosen, Licht, Bad" },
  ];

  function rechneFiTyp(wurzel) {
    const gewaehlt = FI_FRAGEN.filter((f) => wertVon(wurzel, `fi_${f.id}`, false) === true).map((f) => f.id);

    if (!gewaehlt.length) {
      zeigeErgebnis(wurzel, `<p class="asv-rechner__hinweis">Wählen Sie, was am Stromkreis hängt.</p>`);
      return;
    }

    let pruefschritt, begruendung;
    if (gewaehlt.includes("wallbox") || gewaehlt.includes("pv") || gewaehlt.includes("fu3")) {
      pruefschritt = "Herstellerunterlagen und Schutzkonzept prüfen";
      begruendung = `Bei Ladeeinrichtungen, Wechselrichtern und dreiphasigen Umrichtern kann der erforderliche
        Fehlerstromschutz vom konkreten Gerät abhängen. Prüfen Sie die Herstellerangabe zu möglichen Fehlerstromarten,
        einer gegebenenfalls integrierten Fehlerstromerkennung und dem vorgeschriebenen vorgeschalteten Schutzgerät.`;
    } else if (gewaehlt.includes("einphasig_elektronik")) {
      pruefschritt = "Gerätedaten zum Fehlerstromschutz prüfen";
      begruendung = `Bei Geräten mit Leistungselektronik sind Fehlerstromart und Herstellervorgabe Teil der Auswahl.
        Die bloße Gerätebezeichnung bestimmt weder RCD-Typ noch Bemessungsdifferenzstrom.`;
    } else {
      pruefschritt = "Stromkreis und Schutzkonzept prüfen";
      begruendung = `Aus dieser allgemeinen Auswahl lässt sich kein verbindlicher RCD-Typ oder Bemessungsdifferenzstrom
        ableiten. Dafür sind Anlage, Produktunterlagen und die geltenden Anforderungen am Einbauort maßgeblich.`;
    }

    zeigeErgebnis(wurzel, `
      <div class="asv-rechner__treffer">
        <span class="asv-rechner__treffer-label">Prüfschritt Fehlerstromschutz</span>
        <span class="asv-rechner__treffer-wert">${pruefschritt}</span>
        <span class="asv-rechner__treffer-zusatz">keine Geräte- oder Normfreigabe</span>
      </div>
      <p class="asv-rechner__bewertung">${begruendung}</p>
      <p class="asv-rechner__fussnote">Dieser Entwurf enthält keinen Normvolltext und trifft daher keine verbindliche
      Auswahl. Eine Elektrofachkraft muss Schutzmaßnahme, Bemessung und das konkrete Gerät zusammen beurteilen.</p>
    `);
  }

  // --- Rechner 5: IP-Schutzart finden -------------------------------------

  const IP_ORTE = [
    { id: "wohnraum", titel: "Wohnraum, Flur, Büro" },
    { id: "dusche_ohne_wanne", titel: "Dusche ohne Wanne" },
    { id: "bad3", titel: "Bad — außerhalb eines festgelegten Schutzbereichs" },
    { id: "bad2", titel: "Bad — Schutzbereich nach der Planung" },
    { id: "bad1", titel: "Bad — Schutzbereich nach der Planung" },
    { id: "bad0", titel: "Bad — Wanne oder Duschbecken" },
    { id: "aussen_geschuetzt", titel: "Außen, überdacht" },
    { id: "aussen_frei", titel: "Außen, frei bewittert" },
    { id: "keller", titel: "Keller, Garage, Waschküche" },
    { id: "landwirt", titel: "Stall, Werkstatt, Waschplatz" },
  ];

  function rechneIp(wurzel) {
    const ortId = el('[data-feld="ort"]', wurzel)?.value;
    const ort = IP_ORTE.find((o) => o.id === ortId);
    if (!ort) { zeigeErgebnis(wurzel, `<p class="asv-rechner__hinweis">Bitte den Einbauort wählen.</p>`); return; }

    zeigeErgebnis(wurzel, `
      <div class="asv-rechner__treffer">
        <span class="asv-rechner__treffer-label">Einbauort erfasst</span>
        <span class="asv-rechner__treffer-wert">IP-Schutzart prüfen</span>
        <span class="asv-rechner__treffer-zusatz">${ort.titel}</span>
      </div>
      <p class="asv-rechner__bewertung">Aus der Ortsangabe allein folgt keine Schutzart. Prüfen Sie Wasser-,
      Fremdkörper- und Berührungsrisiko, das konkrete Produkt einschließlich Zubehör sowie die geltenden Anforderungen
      für die geplante Anlage.</p>
      <p class="asv-rechner__fussnote">Die erste Ziffer der IP-Kennzahl steht für den Schutz gegen feste Fremdkörper
      und Berührung, die zweite für den Schutz gegen Wasser. Die Kennziffern beschreiben keine vollständige
      Einbau- oder Anlagenfreigabe. Eine Übersicht der Ziffern steht im <a href="/blogs/ratgeber/ip-schutzarten-verstehen">IP-Ratgeber</a>.</p>
    `);
  }

  // --- Tabelle: Strombelastbarkeit ----------------------------------------

  function baueBelastbarkeitsTabelle(wurzel) {
    const verlegeart = el('[data-feld="verlegeart"]', wurzel)?.value || "B2";
    const adern = Number(el('[data-feld="adern"]', wurzel)?.value || 3);
    const haeufung = Number(wertVon(wurzel, "haeufung", 1));
    const temp = Number(wertVon(wurzel, "temperatur", 30));
    const fH = haeufungsFaktor(verlegeart, haeufung);
    const fT = naechsterFaktor(TEMPERATUR, temp);
    const tabelle = BELASTBARKEIT[verlegeart][adern];

    if (!Number.isFinite(fH)) {
      const ziel = el("[data-tabelle]", wurzel);
      if (ziel) ziel.innerHTML = `<p class="asv-rechner__warnung"><strong>Für diese Zahl gebündelter Stromkreise gibt es kein Ergebnis.</strong> Zulässig sind ganze Zahlen von 1 bis 14; die verwendete ABB-Tabelle 7 endet bei 14.</p>`;
      return;
    }

    // Tabelle 5 enthält für PVC (70 °C) Faktoren von 10 °C bis 65 °C. Außerhalb
    // dieses Bereichs wird kein Randwert verwendet: Bei 70 °C ist kein
    // PVC-Faktor veröffentlicht.
    if (!(temp >= 10 && temp <= 65)) {
      const ziel = el("[data-tabelle]", wurzel);
      if (ziel) ziel.innerHTML = `<p class="asv-rechner__warnung"><strong>Für diese Umgebungstemperatur gibt die verwendete ABB-Tabelle 5 keinen Wert her.</strong> Sie deckt für PVC-Leiter (70 °C) 10 °C bis 65 °C ab. Tragen Sie einen Wert in diesem Bereich ein.</p>`;
      return;
    }

    const zeilen = QUERSCHNITTE.filter((a) => tabelle[a] != null).map((a) => {
      const basis = tabelle[a];
      const korrigiert = basis * fH * fT;
      const ls = groessterLs(korrigiert);
      return `<tr>
        <th scope="row">${querschnittText(a)}</th>
        <td>${zahl(basis, 1)} A</td>
        <td class="asv-tabelle__wichtig">${zahl(korrigiert, 1)} A</td>
        <td>${ls ? `B${ls} / C${ls}` : "—"}</td>
      </tr>`;
    }).join("");

    const ziel = el("[data-tabelle]", wurzel);
    if (!ziel) return;
    ziel.innerHTML = `
      <table class="asv-tabelle">
        <caption>Kupferleiter, PVC-isoliert, Verlegeart ${VERLEGEART_TEXT[verlegeart]},
          ${adern} belastete Adern. Häufungsfaktor ${zahl(fH, 2)} (Tabelle 7, Zeile „gebündelt“, Stromkreiszahl aufgerundet),
          Temperaturfaktor ${zahl(fT, 2)} (${zahl(temp, 0)} °C Umgebung, auf die nächsthöhere Tabellenstufe aufgerundet)</caption>
        <thead>
          <tr>
            <th scope="col">Querschnitt</th>
            <th scope="col">Grundwert bei 30 °C</th>
            <th scope="col">Belastbar unter diesen Bedingungen</th>
            <th scope="col">Größter Leitungsschutzschalter</th>
          </tr>
        </thead>
        <tbody>${zeilen}</tbody>
      </table>
      <p class="asv-rechner__fussnote">„Größter Leitungsschutzschalter“ ist der größte Bemessungsstrom der hier geführten Reihe 6, 10, 13, 16, 20, 25, 32, 40, 50, 63 A, der die korrigierte Belastbarkeit nicht überschreitet. Der Tabellenvergleich prüft nur In ≤ Iz. Der Betriebsstrom Ib wird hier nicht abgefragt; Ib ≤ In ist daher zusätzlich anhand der tatsächlichen Last zu prüfen. Für das konkrete Schutzgerät sind I2, Kurzschluss-, Abschalt-, Selektivitäts- und Anschlussbedingungen gesondert zu prüfen. Die Zeile „gebündelt“ ist eine festgelegte Modellannahme für gleichartige, gleich hoch belastete Kabel oder Leitungen; andere Geometrien benötigen ihre eigene Tabellenzeile. Einlagig unter der Decke gilt bei einem Stromkreis beispielsweise 0,95 statt der hier verwendeten 1,00.</p>`;
  }

  // --- Verdrahtung ---------------------------------------------------------

  const RECHNER = {
    kabelquerschnitt: rechneKabelquerschnitt,
    spannungsfall: rechneSpannungsfall,
    verteiler: rechneVerteiler,
    "fi-typ": rechneFiTyp,
    ip: rechneIp,
    strombelastbarkeit: baueBelastbarkeitsTabelle,
  };

  /**
   * Prueft, ob diese Datei noch die aktuelle ist.
   *
   * Abgefragt wird die Stand-Datei ohne Versionsnummer in der Adresse — die
   * liefert immer die neueste Fassung, auch wenn die umgebende Seite aus einem
   * alten Zwischenspeicher kommt. Stimmt der Stand nicht, wird das Ergebnis
   * ersetzt: lieber ein Hinweis als eine veraltete Bemessung.
   *
   * Faellt der Abruf aus (kein Netz auf der Baustelle), passiert nichts. Der
   * Rechner bleibt benutzbar; der Normalfall ist ja, dass alles stimmt.
   */
  async function pruefeStand(wurzeln) {
    const roh = wurzeln[0]?.getAttribute("data-stand-url");
    if (!roh) return;
    // Shopify liefert Theme-Dateien mit einem Jahr Haltbarkeit aus. Ohne eigenen
    // Zusatz stuende die Stand-Datei genauso lange im Zwischenspeicher wie das,
    // was sie ueberwachen soll. Der Zehn-Minuten-Takt erzwingt regelmaessig eine
    // frische Antwort, ohne bei jedem Seitenaufruf einen Abruf auszuloesen.
    const takt = Math.floor(Date.now() / 600000);
    try {
      const res = await fetch(`${roh}?t=${takt}`, { headers: { Accept: "application/json" }, cache: "no-store" });
      if (!res.ok) return;
      const { stand } = await res.json();
      if (!Number.isFinite(stand) || stand <= STAND) return;
      for (const w of wurzeln) {
        zeigeErgebnis(w, `<p class="asv-rechner__warnung"><strong>Diese Seite ist nicht mehr aktuell.</strong>
          Es liegt eine neuere Fassung der Rechengrundlagen vor (Stand ${stand}, hier läuft Stand ${STAND}).
          Bitte laden Sie die Seite neu — bis dahin wird kein Ergebnis angezeigt, damit Sie nicht
          mit überholten Werten planen.</p>`);
        w.dataset.veraltet = "1";
      }
    } catch { /* ohne Netz bleibt der Rechner benutzbar */ }
  }

  function starte() {
    const wurzeln = alle("[data-rechner]");
    if (wurzeln.length) pruefeStand(wurzeln);

    for (const wurzel of wurzeln) {
      const art = wurzel.getAttribute("data-rechner");
      const fn = RECHNER[art];
      if (!fn) continue;

      const rechne = () => {
        if (wurzel.dataset.veraltet) return;
        try { fn(wurzel); } catch (e) { console.error("Rechner", art, e); }
      };

      // Live rechnen: jede Aenderung aktualisiert das Ergebnis sofort. Kein
      // Absenden-Knopf — auf dem Handy ist jeder zusaetzliche Tipp einer zu viel.
      wurzel.addEventListener("input", rechne);
      wurzel.addEventListener("change", rechne);

      // Modusumschalter (Leistung <-> Strom) blendet die passenden Felder ein.
      const modus = el('[data-feld="modus"]', wurzel);
      if (modus) {
        const schalte = () => {
          for (const g of alle("[data-nur-modus]", wurzel)) g.hidden = g.getAttribute("data-nur-modus") !== modus.value;
        };
        modus.addEventListener("change", schalte);
        schalte();
      }

      // 3 % / 5 % sind auswählbare Planungsziele. Ein manuell eingetragener
      // Wert bleibt erhalten und wird sichtbar als individuell markiert.
      const profil = el('[data-feld="spannungsfallprofil"]', wurzel);
      const spannungsfall = el('[data-feld="spannungsfall"]', wurzel);
      if (profil && spannungsfall) {
        profil.addEventListener("change", () => {
          if (profil.value !== "individuell") spannungsfall.value = profil.value;
        });
        spannungsfall.addEventListener("input", () => {
          if (profil.value !== String(spannungsfall.value)) profil.value = "individuell";
        });
      }

      rechne();
    }
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", starte);
  else starte();
})();
